import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const FrameSizeModal = ({ dimensions, onSubmit, onClose }) => {
  const { t } = useTranslation();
  // Par défaut, on suggère des dimensions 20% plus grandes que l'œuvre
  const [frameSize, setFrameSize] = useState({
    height: dimensions?.height ? Math.round(dimensions.height * 1.2 * 10) / 10 : 0,
    width: dimensions?.width ? Math.round(dimensions.width * 1.2 * 10) / 10 : 0,
    depth: 5, // Valeur par défaut
    unit: dimensions?.unit || "cm"
  });

  const handleInputChange = (e) => {
    const { name, value, type } = e.target;
    setFrameSize({
      ...frameSize,
      [name]: type === "number" ? parseFloat(value) || 0 : value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validation de base
    if (frameSize.height <= 0 || frameSize.width <= 0) {
      toast.error(t("artworkModals.common.dimensionsPositive"));
      return;
    }
    
    onSubmit(frameSize);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
         onClick={onClose}>
      <div className="bg-white p-8 rounded-md max-w-lg w-full"
           onClick={(e) => e.stopPropagation()}>
        <div className="flex justify-between items-start mb-6">
          <h3 className="font-serif text-xl">{t("artworkModals.frameSize.title")}</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-black">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="space-y-4">
            <p className="text-sm text-gray-600">
              {t("artworkModals.frameSize.description")}
            </p>
            
            <div className="grid grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-dark mb-1">
                  {t("artworkModals.common.height")}
                </label>
                <input
                  type="number"
                  name="height"
                  value={frameSize.height}
                  onChange={handleInputChange}
                  className="form-control-artsy w-full"
                  min="0"
                  step="0.1"
                  required
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-dark mb-1">
                  {t("artworkModals.common.width")}
                </label>
                <input
                  type="number"
                  name="width"
                  value={frameSize.width}
                  onChange={handleInputChange}
                  className="form-control-artsy w-full"
                  min="0"
                  step="0.1"
                  required
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-dark mb-1">
                  {t("artworkModals.common.depth")}
                </label>
                <input
                  type="number"
                  name="depth"
                  value={frameSize.depth}
                  onChange={handleInputChange}
                  className="form-control-artsy w-full"
                  min="0"
                  step="0.1"
                />
              </div>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-dark mb-1">
                {t("artworkModals.common.unit")}
              </label>
              <div className="flex space-x-4">
                <label className="inline-flex items-center">
                  <input 
                    type="radio" 
                    name="unit" 
                    value="cm"
                    checked={frameSize.unit === "cm"} 
                    onChange={handleInputChange} 
                    className="mr-2"
                  />
                  <span>{t("artworkModals.common.centimeters")}</span>
                </label>
                <label className="inline-flex items-center">
                  <input 
                    type="radio" 
                    name="unit" 
                    value="inches"
                    checked={frameSize.unit === "inches"} 
                    onChange={handleInputChange} 
                    className="mr-2"
                  />
                  <span>{t("artworkModals.common.inches")}</span>
                </label>
              </div>
              <p className="text-xs text-gray-dark mt-1">
                {t("artworkModals.common.inchesHelp")}
              </p>
            </div>
          </div>
          
          <div className="mt-8 flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="btn-artsy btn-secondary-artsy mr-2"
            >
              {t("artworkModals.common.cancel")}
            </button>
            <button
              type="submit"
              className="btn-artsy btn-primary-artsy"
            >
              {t("artworkModals.common.add")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FrameSizeModal;